import * as React from 'react';

const AlertSuccessIcon = ({ color }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12ZM12 20C14.1 20 16.2 19.2 17.7 17.7C19.2 16.2 20 14.1 20 12C20 9.9 19.2 7.8 17.7 6.3C16.2 4.8 14.1 4 12 4C9.9 4 7.8 4.8 6.3 6.3C4.8 7.8 4 9.9 4 12C4 14.1 4.8 16.2 6.3 17.7C7.8 19.2 9.9 20 12 20ZM11 13.1L15.3 8.8C15.7 8.4 16.3 8.4 16.7 8.8C17.1 9.2 17.1 9.8 16.7 10.2L11.7 15.2C11.5 15.4 11.2 15.5 11 15.5C10.8 15.5 10.5 15.4 10.3 15.2L7.3 12.2C6.9 11.8 6.9 11.2 7.3 10.8C7.7 10.4 8.3 10.4 8.7 10.8L11 13.1Z"
      fill={color}
    />
  </svg>
);
export default AlertSuccessIcon;
